import { getHostName } from "../utils";

export async function fetchAdditionalGraphInfo() {
  const data = await fetch(`${getHostName()}/api/additional-graph-info/?format=json`);
  return await data.json();
}
